import React, { useEffect, useRef, useState } from "react";
import { QaMetricsApi } from "../../../../api";
import { Card } from "@mui/material";
import { Divider } from "@monolith-forensics/monolith-ui";
import DropDownSelector from "../../../../components/DropDownSelector";
import Loader from "../../../../components/Loader";
import DefaultPieChart from "../DefaultPieChart";
import DefaultTextChart from "../DefaultTextChart";

const views = [
  {
    text: "Charts",
    value: 0,
  },
  {
    text: "Text",
    value: 1,
  },
];

const ReportComposition = ({ reportInfo }) => {
  const [metrics, setMetrics] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [currentView, setCurrentView] = useState(0);

  useEffect(() => {
    QaMetricsApi.getQaEntryMetrics({
      ...reportInfo.report_parameters,
      dimension: "composition",
    }).then((result) => {
      setMetrics(result);
      setIsLoading(false);
    });
  }, []);

  return (
    <Card
      style={{
        padding: "20px",
        marginBottom: "20px",
        height: "350px",
      }}
    >
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: "larger",
            }}
          >
            QA Entries Composition
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ marginRight: "10px" }}>
              <DropDownSelector
                items={views}
                useSelectMode={true}
                selectedItem={currentView}
                displayExpr="text"
                variant="contained"
                onSelect={(item) => {
                  setCurrentView(item.value);
                }}
              />
            </div>
          </div>
        </div>
        <Divider style={{ margin: "16px 0" }} />
        {isLoading && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Loader />
          </div>
        )}
        {!isLoading && currentView === 0 && (
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <DefaultPieChart
              data={metrics.user_comp}
              title="Examiners"
              valueExpr="examiner"
            />
            <DefaultPieChart
              data={metrics.issue_comp}
              title="QA Issues"
              valueExpr="issue_type"
            />
            <DefaultPieChart
              data={metrics.checklist_comp}
              title="QA Checklist"
              valueExpr="checklist"
            />
            <DefaultPieChart
              data={metrics.group_comp}
              title="QA Group"
              valueExpr="group"
            />
          </div>
        )}
        {!isLoading && currentView === 1 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              userSelect: "text",
            }}
          >
            <DefaultTextChart
              data={metrics.user_comp}
              title="Examiners"
              valueExpr="examiner"
            />
            <DefaultTextChart
              data={metrics.issue_comp}
              title="QA Issues"
              valueExpr="issue_type"
            />
            <DefaultTextChart
              data={metrics.checklist_comp}
              title="QA Checklist"
              valueExpr="checklist"
            />
            <DefaultTextChart
              data={metrics.group_comp}
              title="QA Group"
              valueExpr="group"
            />
          </div>
        )}
      </div>
    </Card>
  );
};

export default ReportComposition;
